export default "__VITE_ASSET__Dt9Kja1z__"